import React from 'react';
import './Nav.css';

import Nav from './Nav.js';
//import onClickOutside from 'react-onclickoutside';


export class NavBurgerMenu extends React.Component {

//This updates when a navburger-menu-item is clicked
//Which means we can close the menu
componentDidUpdate(){
  this.props.onClick();
}

//Uses react-onclickoutside to close mobile menu when clicking outside of it.
/*handleClickOutside = () => {
  this.props.onClick();
} */

  render()
  {
    return(
      <div className="NavBurgerMenu">

        <Nav/> 
      </div>
    )
  }
}
export default NavBurgerMenu;
//export default onClickOutside(NavBurgerMenu);




// WEBPACK FOOTER //
// ./src/Components/Nav/NavBurgerMenu.js